<template>
  <table class="detail-table">
    <tbody>
      <tr>
        <td class="label-col">任务ID</td>
        <td>{{ fullNode.project_node.node_result.taskid }}</td>
      </tr>
      <tr>
        <td class="label-col">首个任务发布时间</td>
        <td>{{ fullNode.project_node.node_result.publishtime }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>

export default {
  components: {},
  mixins: [],
  props: {
    fullNode: {
      type: Object,
      default: () => {},
    },
    projectId: {
      type: String,
      default: '0',
    }
  },
  data () {
    return {}
  },
  created () {},
  computed: {},
  watch: {},
  methods: {},
}
</script>

<style scoped>
.detail-table {
  width: 100%;
  margin-top: 15px;
  border-collapse: collapse;
  border: 1px solid #ebeef5;
}
.detail-table td {
  padding: 12px 10px;
  border: 1px solid #ebeef5;
  color: #606266;
  font-size: 14px;
}
.detail-table .label-col {
  width: 120px;
  background-color: #fafafa;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/project/node-views/TaskOnlineView.vue